import Api from "@/service/api";

/**
 * 服务器获取设备id
 */
export async function getDeviceId(params: {} = {}) {
  return Api.request({
    url: "/config",
    method: "GET",
  });
}

export async function getWallet(params: {} = {}) {
  return Api.request({
    url: "/user/wallet",
    method: "GET",
  });
}

export async function getMarketData(eId: string | number) {
  return Api.request({
    url: "/askpaul/market/" + eId,
    method: "GET",
  });
}

export async function marketBuy(data: {} = {}) {
  return Api.request({
    url: "/askpaul/market/buy",
    method: "POST",
    data: { ...data }
  });
}

export async function marketSell(data: {} = {}) {
  return Api.request({
    url: "/askpaul/market/sell",
    method: "POST",
    data: { ...data }
  });
}

export async function unreadCount<T>(params: {  } = {}) {
  return Api.request({
    url: "/assistant/unread_count",
    method: "GET",
  });
}

export async function markRead<T>(params: { chat_id: string }) {
  return Api.request({
    url: "/assistant/mark_read",
    method: "POST",
    data: { ...params }
  });
}

export async function getShippingFeeConf<T>(data: {} = {}) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        data: {
          deviceId: "123456789",
        }
      });
    }, 1000);
  });
  // return Api.request<T>({
  //   url: "/express/getShippingFeeConf",
  //   method: "POST",
  //   data: { ...data }
  // });
}